import { ERROR_TRANSLATION_KEYS, translateError } from "../errorTranslations.js";

export function getUserFriendlyErrorMessage(error) {
    if (!error) return "";

    // A catalog code already has approved, localisable copy — prefer it over
    // the WebAuthn heuristics below (COI-779, ADR-0032). The map lookup is what
    // makes this safe: error.code is also where EIP-1193 puts its numeric
    // rejection codes, and those must still fall through to the heuristics.
    if (ERROR_TRANSLATION_KEYS[error.code]) {
      const coded = translateError(error, "");
      if (coded) return coded;
    }

    const errorMessage = error.message || error.toString();
    const errorName = error.name || '';

    // Handle specific WebAuthn errors
    if (errorName === 'NotAllowedError' || errorMessage.includes('NotAllowedError')) {
      return "Authentication was cancelled or failed.";
    }

    if (errorName === 'AbortError' || errorMessage.includes('AbortError')) {
      return "Authentication was cancelled.";
    }

    if (errorName === 'TimeoutError' || errorMessage.includes('TimeoutError')) {
      return "Authentication timed out.";
    }

    if (errorName === 'NotSupportedError' || errorMessage.includes('NotSupportedError')) {
      return "Authentication is not supported on this device.";
    }

    if (errorName === 'SecurityError' || errorMessage.includes('SecurityError')) {
      if (errorMessage.includes('relying party ID') || errorMessage.includes('registrable domain')) {
        return "Something wen't wrong. Please contact support.";
      }
      return "Something wen't wrong. Please contact support.";
    }

    if (errorName === 'InvalidStateError' || errorMessage.includes('InvalidStateError')) {
      return "Something wen't wrong. Please contact support.";
    }

    // If it's a user-friendly message already, return it as is
    return errorMessage;
  }